// Configuration for notable labels per assessment type
// Notable labels indicate unexpected or clinically significant findings worthy of attention

export const NOTABLE_LABELS_CONFIG = {
  explain_review_admit_dc: {
    appropriate_loc_prospective: {
      notableValues: ['should_be_higher', 'should_be_lower', 'should_be_outpatient', 'should_be_outpatient_if_pdm'],
      label: 'LOC Prospective'
    },
    appropriate_loc_retrospective: {
      notableValues: ['should_be_higher', 'should_be_lower', 'should_be_outpatient', 'should_be_outpatient_if_pdm'],
      label: 'LOC Retrospective'
    },
    significant_findings: {
      notableValues: ['yes'],
      label: 'Significant Findings'
    },
    diagnostic_clarity: {
      notableValues: ['refined', 'changed'],
      label: 'Diagnostic Clarity'
    },
    modifiable_admission: {
      notableValues: ['outpatient', 'urgent-outpatient', 'pdm', 'ED', 'social', 'other'],
      label: 'Modifiable Admission'
    },
    therapeutic_pivot_ip: {
      notableValues: ['yes'],
      label: 'Therapeutic Pivot (IP)'
    },
    value_of_care_ip: {
      notableValues: ['low', 'negative'],
      label: 'Value of Care (IP)'
    }
  },
  explain_review_revisit: {
    predictability: {
      notableValues: ['Possibly', 'Likely'],
      label: 'Predictability'
    },
    preventability: {
      notableValues: ['Possibly', 'Likely'],
      label: 'Preventability'
    },
    post_discharge_monitoring: {
      notableValues: ['Possibly', 'Likely'],
      label: 'PDM Opportunity'
    },
    dci: {
      notableValues: ['Possibly', 'Likely'],
      label: 'DCI Opportunity'
    }
  },
  explain_review_edd: {
    post_discharge_monitoring: {
      notableValues: ['Possibly', 'Likely'],
      label: 'PDM Opportunity'
    },
    value_of_care_edd: {
      notableValues: ['low', 'negative'],
      label: 'Value of Care'
    }
  }
} as const;

export type AssessmentType = keyof typeof NOTABLE_LABELS_CONFIG;
